import { render, staticRenderFns } from "./ReasonsChart.vue?vue&type=template&id=56634c5c&scoped=true"
import script from "./ReasonsChart.vue?vue&type=script&lang=js"
export * from "./ReasonsChart.vue?vue&type=script&lang=js"
import style0 from "./ReasonsChart.vue?vue&type=style&index=0&id=56634c5c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56634c5c",
  null
  
)

export default component.exports